import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_ADD_CAMPAIGN } from "../api/campaign.service";

const initialState = {
  campaignData: [],
  campaignLoading: false,
}

export const addCampaign = createAsyncThunk(
  "campaign/addCampaign",
  async (campaignData, thunkAPI) => {
    try {
      let data = await API_ADD_CAMPAIGN(campaignData);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

const campaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {},
  
  extraReducers: (builder) => {
    builder.addCase(addCampaign.fulfilled, (state, action) => {
        state.campaignLoading=false;
        state.campaignData = action.payload;
    });
    builder.addCase(addCampaign.pending, (state) => {
      state.campaignLoading = true;
    });
    builder.addCase(addCampaign.rejected, (state) => {
      state.campaignLoading = false;
    });
  }

});

export default campaignSlice.reducer;